import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Facilitiess from './components/Facilitiess';

const facilitiess = (props,{ t }) => (
  <Container>
    <Facilitiess {...props} />
  </Container>
);

facilitiess.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(facilitiess);
